"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var ExpandedRowContext = /*#__PURE__*/React.createContext(null);
var _default = ExpandedRowContext;
exports.default = _default;